import { useEffect, useState } from 'react';

interface PageLoadingProps {
  delay?: number; // 延迟显示的毫秒数，默认为 0
}

export default function PageLoading({ delay = 0 }: PageLoadingProps) {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(delay === 0);

  useEffect(() => {
    // 处理延迟显示
    if (delay > 0) {
      const delayTimer = setTimeout(() => {
        setVisible(true);
      }, delay);

      return () => clearTimeout(delayTimer);
    }
  }, [delay]);

  useEffect(() => {
    if (!visible) return;

    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 95) {
          clearInterval(interval);
          return 95;
        }

        // 模拟不同阶段的加载速度
        let increment;
        if (prev < 30) {
          increment = Math.random() * 8 + 2; // 0-30%: 快速增长 2-10%
        } else if (prev < 70) {
          increment = Math.random() * 4 + 1; // 30-70%: 中等速度 1-5%
        } else {
          increment = Math.random() * 2 + 0.5; // 70-95%: 缓慢增长 0.5-2.5%
        }

        return Math.min(prev + increment, 95);
      });
    }, 150); // 每150ms更新一次

    return () => clearInterval(interval);
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* 进度条背景 */}
      <div className="h-1 bg-transparent">
        {/* 进度条 */}
        <div className="h-full bg-black/50 transition-all duration-300 ease-out" style={{ width: `${progress}%` }} />
      </div>

      {/* 可选：添加一个微妙的阴影效果 */}
      <div className="h-0.5 bg-black/20 blur-sm" style={{ width: `${progress}%` }} />
    </div>
  );
}
